import { Heading } from '@dbt-labs/sourdough';

import { PageLayout } from '@/components/PageLayout';
import { SearchInput } from '@/components/SearchInput';
import { useDbtCloudProject } from '@/context/DbtCloudProjectProvider';
import { useUrlProjectParams } from '@/hooks/params';
import { DatabaseFilter } from './DatabaseFilter/DatabaseFilter';
import { FileTreeFilter } from './FileTreeFilter/FileTreeFilter';
import { usePanelView } from './panelView';
import { PanelViewSwitcher } from './PanelViewSwitcher';
import { ResourcesFilter } from './ResourcesFilter/ResourcesFilter';

export const SinglePaneNavPanel = () => {
  const projectScope = useUrlProjectParams();

  const [navMode, updateNavMode] = usePanelView();
  const { accountId, projectName, account } = useDbtCloudProject();

  if (!accountId) {
    return <>Invalid account ID</>;
  }
  if (!projectScope) {
    return <>Invalid URL</>;
  }
  return (
    <PageLayout isLoading={!account}>
      <div data-testid="single-pane-nav" className="h-full w-full">
        <div className="mb-4">
          <Heading component="h1" size={'6'} children={projectName} />
        </div>
        <SearchInput />
        <PanelViewSwitcher navMode={navMode} updateNavMode={updateNavMode} />
        <div className="h-full flex-1">
          {navMode === 'fileTree' ? (
            <FileTreeFilter />
          ) : (
            <>
              {navMode === 'resources' && <ResourcesFilter />}
              {navMode === 'database' && <DatabaseFilter />}
            </>
          )}
        </div>
      </div>
    </PageLayout>
  );
};
